import { Tabs, TabsContent, TabsList, TabsTrigger } from "@workspace/web-ui/components/tabs"
import EncountersTag from "./encounters-tag"
import EmptyState from "./empty-state"
import EncountersDetailsOverview from "./encounters-details-overview"
import EncountersDetailsAppointments from "./encounters-details-appointments"
import EncountersDetailsChatHistory from "./encounters-details-chat-history"
import EncountersDetailsPrescription from "./encounters-details-prescription"
import { Button } from "@workspace/web-ui/components/button"
import { Skeleton } from "@workspace/web-ui/components/skeleton"

export default function EncountersDetails({resumeChatWithAlfie,prescriptionsQuery,isLoading, encounter,chatHistoryQuery,appointmentsQuery}:{resumeChatWithAlfie: (message:string,agent_id:string, thread_id: string,session_id:string) => void, prescriptionsQuery:any, isLoading:boolean, encounter:any,chatHistoryQuery:any,appointmentsQuery:any}) {
    // console.log('encounter',encounter) 
    // const latestOnboardingChat = chatHistoryQuery.data?.chat_history.onboard_chat_history[chatHistoryQuery.data?.chat_history.onboard_chat_history.length - 1];
    const lastMessage = chatHistoryQuery.data?.chat_history.alfie_chat_history[chatHistoryQuery.data?.chat_history.alfie_chat_history.length - 1]?.message?.data?.content;

    const handleChatBotOpen = () => {
      resumeChatWithAlfie(lastMessage, encounter?.session?.agent_id, encounter?.session?.thread_id,encounter?.session?.session_id);
        // Logic to open the chat bot
        console.log("Chat bot opened");
        console.log("Chat bot opened",lastMessage, encounter?.session?.agent_id, encounter?.session?.thread_id,encounter?.session?.session_id);
    };
    return (
    <>{isLoading !== true ?
    (        <div className="border rounded-[12px] border-[#04040466] py-[20px] h-fit">
            {encounter  !== null  && encounter !== undefined && Object.keys(encounter).length > 0 ? <>           
           <div className="flex flex-col  gap-2 px-[20px]">
                <h1 className="text-[#1A202C] text-[24px] font-medium leading-[130%] tracking-[-2%]">{encounter?.session?.diagnosis?.[0]?.disease_name ? encounter?.session?.diagnosis?.[0]?.disease_name : `#${encounter?.session?.session_number} Session`}</h1>
                 <span className="text-[#464B55] text-[14px] leading-[140%] font-normal tracking-[-1%]">Started:{encounter?.session?.start_datetime}</span>
                <div className="flex flex-wrap items-center gap-[8px]">
                    <EncountersTag type={encounter?.session?.onboard_session ==='ended' && encounter?.session?.alfie_session === 'ended' ? "":"in_progress"} />
                    <EncountersTag type={encounter?.session?.onboard_session ==='ended' && encounter?.session?.alfie_session === 'ended' ? "Closed":"action_needed"} />
                    <EncountersTag type={encounter?.session?.is_red_flagged === true ? "red_flagged" : ""} />
                    <EncountersTag type={encounter?.session?.treatment_completed === true ? "treatment_completed" : ""} />
                </div>
                {encounter?.session?.onboard_session ==='ended' && encounter?.session?.alfie_session === 'ended' ? (             
                   <Button  className="border-[#DCDCDE]   h-auto w-full text-[#FFFFFF] !py-[12px] !px-[16px] rounded-[10px]">
                Complete consultation payment - $50.00
            </Button>
):(             
   <Button onClick={() => handleChatBotOpen()}  className="border-[#DCDCDE]   h-auto w-full text-[#FFFFFF] !py-[12px] !px-[16px] rounded-[10px]">
Resume chat with Alfie
</Button>
)}

             </div>
            <div className="flex flex-col gap-[8px] mt-6">
                <Tabs defaultValue="overview" className="w-full">
                    <TabsList className="flex w-full items-start overflow-x-scroll rounded-none my-0 justify-around gap-2 border-b bg-transparent px-0 py-0">
                        <TabsTrigger 
                            value="overview" 
                            className="text-[#464B55] text-[14px] leading-[140%] font-normal !my-0 tracking-[-1%] px-3 py-2 rounded-none border-b-2 border-transparent !bg-transparent data-[state=active]:border-[#4272DD] data-[state=active]:text-[#4272DD] transition-all"
                        >
                            Overview
                        </TabsTrigger>
                        <TabsTrigger 
                            value="chat-history" 
                            className="text-[#464B55] text-[14px] leading-[140%] font-normal !my-0 tracking-[-1%] px-4 py-2 rounded-none border-b-2 border-transparent !bg-transparent data-[state=active]:border-[#4272DD] data-[state=active]:text-[#4272DD] transition-all"
                        >
                            Chat History
                        </TabsTrigger>
                        <TabsTrigger 
                            value="appointments" 
                            className="text-[#464B55] text-[14px] leading-[140%] font-normal !my-0 tracking-[-1%] px-4 py-2 rounded-none border-b-2 border-transparent !bg-transparent data-[state=active]:border-[#4272DD] data-[state=active]:text-[#4272DD] transition-all"
                        >
                            Appointments
                        </TabsTrigger>
                        <TabsTrigger 
                            value="prescription" 
                            className="text-[#464B55] text-[14px] leading-[140%] font-normal !my-0 tracking-[-1%] px-4 py-2 rounded-none border-b-2 border-transparent !bg-transparent data-[state=active]:border-[#4272DD] data-[state=active]:text-[#4272DD] transition-all"
                        >
                            Prescription
                        </TabsTrigger>
                    </TabsList>
                    <TabsContent value="overview" className="mt-4 overflow-y-scroll max-h-[41vh]">
                    <EncountersDetailsOverview encounter={encounter} />                      
                     </TabsContent>
                    <TabsContent value="chat-history" className="mt-4 overflow-y-scroll max-h-[41vh]">
                      <EncountersDetailsChatHistory resumeChatWithAlfie={() => handleChatBotOpen()} encounter={encounter} chatHistory={chatHistoryQuery?.data?.chat_history} />
                    </TabsContent>
                    <TabsContent value="appointments" className="mt-4 overflow-y-scroll max-h-[41vh]">
                      <EncountersDetailsAppointments appointments={appointmentsQuery?.data?.appointments} />
                    </TabsContent>
                    <TabsContent value="prescription" className="mt-4 overflow-y-scroll max-h-[41vh]">
                      <EncountersDetailsPrescription prescriptions={prescriptionsQuery} />
                    </TabsContent>
                </Tabs>
            </div> </> : 
            <div className="flex flex-col gap-[8px] h-[50vh] px-[16px] justify-center items-center">
                <EmptyState title="No encounter available" message="Create a new encounter to get started" type="encounters" />
            </div>}

        </div>):(
          <div className="border rounded-[12px] border-[#04040466] h-fit py-[20px]">
            <div className="flex flex-col gap-2 px-[20px]">
              <Skeleton className="h-[32px] w-[300px]" />
              <Skeleton className="h-[20px] w-[200px]" />
              <div className="flex flex-wrap items-center gap-[8px]">
                <Skeleton className="h-[24px] w-[100px]" />
                <Skeleton className="h-[24px] w-[100px]" />
                <Skeleton className="h-[24px] w-[100px]" />
              </div>
            </div>
            <div className="flex flex-col gap-[8px] mt-6">
              <div className="flex gap-2 border-b px-4 py-2">
                <Skeleton className="h-[40px] w-[100px]" />
                <Skeleton className="h-[40px] w-[100px]" />
                <Skeleton className="h-[40px] w-[100px]" />
                <Skeleton className="h-[40px] w-[100px]" />
              </div>
              <div className="mt-4 px-4">
                <Skeleton className="h-[200px] w-full" />
              </div>
            </div>
          </div>) }
    </>

    )
}